export const COUNTRY_RISK_LEVELS = ['LOW', 'STANDARD', 'HIGH'] as const;

export type CountryRiskLevel = (typeof COUNTRY_RISK_LEVELS)[number];

export type CountryRisk = {
  id: number;
  isoCode: string | null;
  name: string | null;
  risk: CountryRiskLevel | null;
};
